import React, { useEffect } from "react";
import { setImpToken } from "@/lib/api";

// Consumes a super-admin quick-login link. The token rides in the URL hash (never sent to the
// server / logs) and is stored in sessionStorage so THIS tab gets its own identity. A full
// reload to /dashboard re-initializes the app as the impersonated user.
export default function ImpersonatePage() {
  useEffect(() => {
    const raw = window.location.hash || "";
    const params = new URLSearchParams(raw.startsWith("#") ? raw.slice(1) : raw);
    const token = params.get("token");
    if (token) {
      setImpToken(token);
      window.location.replace("/dashboard");
    } else {
      window.location.replace("/login");
    }
  }, []);

  return (
    <div className="bg-grain min-h-screen flex items-center justify-center text-[#000000] font-display">
      Signing you in…
    </div>
  );
}
